import React from "react";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Navigation } from "swiper/modules";

const BlogPosts = ({ posts = null, className = "py-12 lg:py-20" } = {}) => {
  const { title = "", blogs = [], button = null } = posts || {};

  if (!posts || !blogs?.length) return null;
  return (
    <section className={`carousel-card overflow-hidden bg-white ${className}`}>
      <div className="container mx-auto">
        <div className=" flex flex-wrap">
          {title && (
            <div className="w-full basis-full px-4">
              <h2 className=" mb-8 text-center font-openSans text-4xl capitalize text-secondary">
                {title}
              </h2>
            </div>
          )}
          {blogs?.length > 0 ? (
            <div className="w-full basis-full px-4">
              <Swiper
                slidesPerView={1}
                spaceBetween={30}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                loop={true}
                navigation={true}
                modules={[Navigation]}
              >
                {blogs?.map((blog) => {
                  const image = getImage(
                    blog?.featuredImage?.node?.localFile?.childImageSharp
                      .gatsbyImageData
                  );
                  const title =
                    blog?.title.length > 60
                      ? `${blog?.title.slice(0, 57)}...`
                      : blog?.title;
                  return (
                    <SwiperSlide
                      key={blog?.id}
                      className="h-full-minus bg-primary "
                    >
                      <div className="flex h-[360px] flex-col justify-between p-9">
                        <div className="w-full">
                          <h3 className="mb-4 font-openSans text-2xl text-white">
                            <Link to={blog?.uri}>{title}</Link>
                          </h3>

                          <div
                            className="mb-6 font-openSans text-base text-white"
                            dangerouslySetInnerHTML={{
                              __html: blog?.excerpt,
                            }}
                          ></div>
                        </div>

                        {blog?.uri ? (
                          <Link to={blog?.uri} className="flex items-center">
                            <svg
                              width="30"
                              height="31"
                              viewBox="0 0 30 31"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.7998 15.8179H25.3331"
                                stroke="white"
                                strokeWidth="0.933333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16.9326 7.418L25.3326 15.818L16.9326 24.218"
                                stroke="white"
                                strokeWidth="0.933333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </Link>
                        ) : null}
                      </div>
                      <GatsbyImage
                        image={image}
                        alt={title}
                        className="h-[120px] w-full object-center"
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          ) : null}

          {button ? (
            <Link
              to={button?.url}
              className="mx-auto mt-10 inline-block rounded-xl bg-primary px-12 py-2 text-white transition-all duration-500 hover:bg-secondary"
            >
              {button?.title}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default BlogPosts;
